import React from 'react';
import fields, { FIELDS, INPUTS } from 'modules/cm/fields/types';
import { VARIANTS_TYPES } from 'modules/af_cm_ui_kit/components/TextField/variants.types';
import styles from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant/PersonalDetails/PersonalDetails.module.scss';
import { Props } from 'modules/cm/pages/CaseDetailsPage/subPages/Applicant/PersonalDetails/PreviousAddresses/PreviousAddresses.types';
import css from './PreviousAddresses.module.scss';
import { Icon } from 'modules/af_cm_ui_kit/components';
import UpdatableField from 'modules/cm/fields/UpdatableField';
import { FieldWithError } from '../../../../hooks/useFieldError/FieldWithError';

export const PreviousAddressWrapper: React.FC = ({ children }) => {
  return <div className={css.wrapper}>{children}</div>;
};

const PreviousAddressItem: React.FC<Props & FieldWithError> = ({
  modulePrefix,
  onAddressDelete,
  item,
  index,
  getErrors,
  isCaseReadOnly,
}) => {
  const getErrorsForIndex = (index: number) => (fieldName: string) => {
    return getErrors(`${index}.${fieldName}`);
  };

  return (
    <>
      <div className={css.actionsRow}>
        <div className={css.content}>
          <UpdatableField
            getErrors={getErrorsForIndex(index)}
            modulePrefix={modulePrefix}
            fieldType={INPUTS.TEXT}
            field={fields[FIELDS.APPLICANT_PREVIOUS_ADDRESSES](index)[FIELDS.APPLICANT_ADDRESS_FLAT_NUMBER]}
            isCaseReadOnly={isCaseReadOnly}
          />
        </div>

        <div className={css.actions}>
          <button type="button" className={css.button} onClick={() => onAddressDelete()} disabled={isCaseReadOnly}>
            <Icon type="trash" />
          </button>
        </div>
      </div>

      <UpdatableField
        getErrors={getErrorsForIndex(index)}
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXT}
        field={fields[FIELDS.APPLICANT_PREVIOUS_ADDRESSES](index)[FIELDS.APPLICANT_ADDRESS_BUILDING_NAME]}
        isCaseReadOnly={isCaseReadOnly}
      />
      <UpdatableField
        getErrors={getErrorsForIndex(index)}
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXT}
        field={fields[FIELDS.APPLICANT_PREVIOUS_ADDRESSES](index)[FIELDS.APPLICANT_ADDRESS_BUILDING_NUMBER]}
        isCaseReadOnly={isCaseReadOnly}
      />
      <UpdatableField
        getErrors={getErrorsForIndex(index)}
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXT}
        field={fields[FIELDS.APPLICANT_PREVIOUS_ADDRESSES](index)[FIELDS.APPLICANT_ADDRESS_STREET]}
        isCaseReadOnly={isCaseReadOnly}
      />
      <UpdatableField
        getErrors={getErrorsForIndex(index)}
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXT}
        field={fields[FIELDS.APPLICANT_PREVIOUS_ADDRESSES](index)[FIELDS.APPLICANT_ADDRESS_CITY]}
        isCaseReadOnly={isCaseReadOnly}
      />
      <UpdatableField
        getErrors={getErrorsForIndex(index)}
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXT}
        field={fields[FIELDS.APPLICANT_PREVIOUS_ADDRESSES](index)[FIELDS.APPLICANT_ADDRESS_POSTCODE]}
        variant={VARIANTS_TYPES.POSTCODE}
        isCaseReadOnly={isCaseReadOnly}
      />
      <UpdatableField
        getErrors={getErrorsForIndex(index)}
        modulePrefix={modulePrefix}
        fieldType={INPUTS.TEXT}
        field={fields[FIELDS.APPLICANT_PREVIOUS_ADDRESSES](index)[FIELDS.APPLICANT_ADDRESS_MOVED_IN_DATE]}
        variant={VARIANTS_TYPES.DATE}
        isCaseReadOnly={isCaseReadOnly}
      />
      <hr className={styles.divider} />
    </>
  );
};

export default PreviousAddressItem;
